const ALLOWED_URL = /^(?:https?:)?\//i;

// Use for any url() built from API data. Chakra style props end up as text in an emotion
// stylesheet, so an unquoted value containing `)` `;` `}` can close the rule and add global CSS.
export const cssUrl = (value: string | null | undefined): string | undefined => {
  const url = value?.trim();
  if (!url || !ALLOWED_URL.test(url)) return undefined;

  // Commas are hex-escaped too: Chakra's backgroundImage transform rewrites any url() containing
  // one into an invalid url-gradient(), which drops Cloudinary URLs like .../c_fill,w_700/...
  const escaped = url
    .replace(/["\\]/g, '\\$&')
    .replace(/[\n\r\f,]/g, (char) => `\\${char.charCodeAt(0).toString(16)} `);

  return `url("${escaped}")`;
};
